exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sensor-table {\n  margin-top: 20px;\n  color: #fff;\n}\n.sensor-table-status.error {\n  color: #f00;\n}\n", ""]);
